// Виклики API. Cookie сесії ставить сервер (httpOnly); тут лише JSON і помилки.
export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

export async function api(path, { method = "GET", body } = {}) {
  const res = await fetch(path, {
    method,
    credentials: "same-origin",
    headers: body !== undefined ? { "Content-Type": "application/json" } : {},
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(res.status, data.error || `Помилка ${res.status}`);
  return data;
}

export const money = (v) =>
  v == null ? "" : Number(v).toLocaleString("uk-UA", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const day = (v) => (v ? String(v).slice(0, 10).split("-").reverse().join(".") : "");

export const dateTime = (v) => {
  if (!v) return "";
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return String(v);
  return d.toLocaleString("uk-UA", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
};
// Дата з кабінету («2026-06-17 11:00:11») → «17.06.2026 11:00»
export const cabDateTime = (v) => {
  if (!v) return "";
  const [d, t = ""] = String(v).split(/[ T]/);
  return `${day(d)}${t ? " " + t.slice(0, 5) : ""}`;
};
export const percent = (v, digits = 2) =>
  v == null ? "" : `${(Number(v) * 100).toLocaleString("uk-UA", { maximumFractionDigits: digits })} %`;

// Завантаження файлу з API: помилку показуємо текстом, а не JSON-сторінкою
export async function download(path) {
  const res = await fetch(path, { credentials: "same-origin" });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new ApiError(res.status, data.error || `Помилка ${res.status}`);
  }
  const cd = res.headers.get("content-disposition") || "";
  const name = decodeURIComponent((cd.match(/filename="?([^"]+)"?/) || [])[1] || "file");
  const url = URL.createObjectURL(await res.blob());
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

// Дата МД: «20260811T101500» → «11.08.2026»; ISO і «рррр-мм-дд …» — як day()
export const anyDay = (v) => {
  const s = String(v || "");
  const m = s.match(/^(\d{4})(\d{2})(\d{2})(T|$)/);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : day(s);
};
